import React from 'react';
import { useDeepMemo } from '@beeline.com/bp-design-system';
import { useCustomObjectValuesIntl } from '@oc/pages/settings/CustomFieldsAndObjects/Objects/CustomObjectValues/translations/useCustomObjectValuesIntl';
import { CustomObjectValuesActions } from '@oc/pages/settings/CustomFieldsAndObjects/Objects/CustomObjectValues/CustomObjectValuesActions';
import {
  CustomObject,
  CustomObjectColumn
} from '@oc/pages/settings/CustomFieldsAndObjects/Objects/CustomObjectValues/CustomObject.types';
import { CustomObjectValueStatus } from '@oc/pages/settings/CustomFieldsAndObjects/Objects/CustomObjectValues/CustomObjectValueStatus';

interface Props {
  onEdit: (customObject: CustomObject) => void;
  onDelete: (customObject: CustomObject) => void;
}

export const useCustomObjectValuesColumns = ({ onEdit, onDelete }: Props): CustomObjectColumn[] => {
  const intl = useCustomObjectValuesIntl();
  return useDeepMemo(
    (): CustomObjectColumn[] => [
      {
        Header: intl.id,
        accessor: 'uid',
        id: 'uid',
        Cell: ({ value }) => value ?? '-'
      },
      {
        Header: intl.name,
        accessor: 'name',
        Cell: ({ value }) => value ?? '-'
      },
      {
        Header: intl.description,
        accessor: 'description',
        Cell: ({ value }) => value ?? '-'
      },
      {
        Header: intl.status,
        accessor: 'status',
        minWidth: 120,
        Cell: ({ value }) => (value ? <CustomObjectValueStatus status={value} /> : '-')
      },
      {
        Header: intl.referenceId,
        accessor: 'referenceId',
        Cell: ({ value }) => value ?? '-'
      },
      {
        Header: intl.referenceCode,
        accessor: 'referenceCode',
        Cell: ({ value }) => value ?? '-'
      },
      {
        Header: '',
        accessor: (row) => <CustomObjectValuesActions customObject={row} onEdit={onEdit} onDelete={onDelete} />,
        id: '[menu]',
        sticky: 'right'
      }
    ],
    [intl.id, intl.name, intl.description, intl.status, intl.referenceId, intl.referenceCode, onEdit, onDelete]
  );
};
